(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-with-tabs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.stl-tab').forEach(tab => {
  tab.addEventListener('click', () => {
    document.querySelectorAll('.stl-tab').forEach(t => t.classList.remove('active'));
    document.querySelectorAll('.stl-panel').forEach(p => p.classList.remove('active'));
    tab.classList.add('active');
    document.getElementById(tab.dataset.target).classList.add('active');
  });
});

  } catch(e) { console.error(e); }
})();
})();
